
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-3 lg:py-6">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/e98866bb21555bc01871226869278e9c/d81c89946136bef8b2a90450a4ebf256.png" 
                alt="Navik Pro Sale" 
                className="h-7 w-auto sm:h-8 lg:h-10"
                style={{ maxWidth: 'none' }}
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-8">
              <a href="#features" className="text-gray-600 hover:text-orange-500 transition-colors">
                Tính năng
              </a>
              <a href="#benefits" className="text-gray-600 hover:text-orange-500 transition-colors">
                Lợi ích
              </a>
              <a href="#zero-cost" className="text-gray-600 hover:text-orange-500 transition-colors">
                Không cần vốn
              </a>
              <a href="#contact" className="text-gray-600 hover:text-orange-500 transition-colors">
                Liên hệ
              </a>
            </nav>

            {/* Desktop Auth Buttons */}
            <div className="hidden sm:flex items-center space-x-3">
              <Link
                to="/login"
                className="px-4 py-2 text-gray-600 hover:text-black transition-colors text-sm lg:text-base whitespace-nowrap"
              >
                Đăng nhập
              </Link>
              <Link
                to="/register"
                className="px-4 py-2 lg:px-6 lg:py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-medium text-sm lg:text-base whitespace-nowrap"
              >
                Đăng ký
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="sm:hidden p-2 text-gray-600 hover:text-black transition-colors"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="sm:hidden border-t border-gray-200 py-4 bg-white">
              <nav className="flex flex-col space-y-4">
                <a 
                  href="#features" 
                  className="text-gray-600 hover:text-orange-500 transition-colors py-2 px-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Tính năng
                </a>
                <a 
                  href="#benefits" 
                  className="text-gray-600 hover:text-orange-500 transition-colors py-2 px-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Lợi ích
                </a>
                <a 
                  href="#zero-cost" 
                  className="text-gray-600 hover:text-orange-500 transition-colors py-2 px-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Không cần vốn
                </a>
                <a 
                  href="#contact" 
                  className="text-gray-600 hover:text-orange-500 transition-colors py-2 px-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Liên hệ
                </a>
                <div className="flex flex-col space-y-3 pt-4 border-t border-gray-200">
                  <Link
                    to="/login"
                    className="text-center py-2 px-4 text-gray-600 hover:text-black transition-colors border border-gray-300 rounded-lg"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Đăng nhập
                  </Link>
                  <Link
                    to="/register"
                    className="text-center py-2 px-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-medium"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Đăng ký
                  </Link>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative py-12 sm:py-16 lg:py-28 bg-cover bg-center min-h-[500px] sm:min-h-[600px] lg:min-h-[700px] flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/e98866bb21555bc01871226869278e9c/b54d496684fc71dfd1001cf7cec4becc.jpeg')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl text-center sm:text-left">
            <h1 className="text-2xl sm:text-3xl lg:text-6xl font-bold text-white mb-3 sm:mb-4 lg:mb-6 leading-tight">
              Bắt đầu kinh doanh với
              <span className="text-orange-400"> 0 đồng</span>
              <br />
              cùng Navik Pro Sale
            </h1>
            <p className="text-sm sm:text-base lg:text-xl text-gray-200 mb-6 lg:mb-8 leading-relaxed max-w-3xl">
              Tham gia Navik Pro Sale - Nền tảng bán hàng thông minh, minh bạch.
              <br className="hidden sm:block" />
              Không cần nhập hàng, Không lo tồn kho, Không lo về vốn. Hoa hồng lên đến 25%!
            </p>
            <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4 mb-6 lg:mb-8">
              <Link
                to="/register"
                className="px-6 py-3 sm:px-8 sm:py-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-semibold text-base lg:text-lg inline-flex items-center justify-center whitespace-nowrap"
              >
                Bắt đầu với 0 đồng
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <a
                href="#zero-cost"
                className="px-6 py-3 sm:px-8 sm:py-4 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-lg hover:bg-white/20 transition-colors font-semibold text-base lg:text-lg inline-flex items-center justify-center whitespace-nowrap"
              >
                Tìm hiểu thêm
              </a>
            </div>
            <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:flex lg:flex-wrap lg:gap-6 text-white">
              <div className="flex items-center justify-center sm:justify-start">
                <i className="ri-check-line text-orange-400 mr-2 text-lg"></i>
                <span className="text-sm lg:text-base">Không cần vốn</span>
              </div>
              <div className="flex items-center justify-center sm:justify-start">
                <i className="ri-check-line text-orange-400 mr-2 text-lg"></i>
                <span className="text-sm lg:text-base">Không tồn kho</span>
              </div>
              <div className="flex items-center justify-center sm:justify-start">
                <i className="ri-check-line text-orange-400 mr-2 text-lg"></i>
                <span className="text-sm lg:text-base">Hoa hồng cao</span>
              </div>
              <div className="flex items-center justify-center sm:justify-start">
                <i className="ri-check-line text-orange-400 mr-2 text-lg"></i>
                <span className="text-sm lg:text-base">Thanh toán nhanh</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Zero Cost Section */}
      <section id="zero-cost" className="py-12 sm:py-16 lg:py-20 bg-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-black mb-3 sm:mb-4">
              Tại sao chọn mô hình 0 đồng vốn?
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
              Khác với kinh doanh truyền thống, bạn không cần lo lắng về rủi ro tài chính
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                icon: 'ri-money-dollar-circle-line',
                title: 'Không cần vốn ban đầu',
                description: 'Bắt đầu ngay hôm nay mà không cần đầu tư một đồng nào. Chúng tôi lo tất cả về sản phẩm và kho hàng.',
                highlight: '0 đồng vốn'
              },
              {
                icon: 'ri-store-line',
                title: 'Không lo tồn kho',
                description: 'Sản phẩm được quản lý tập trung. Bạn chỉ cần tập trung bán hàng và chăm sóc khách hàng.',
                highlight: 'Không rủi ro'
              },
              {
                icon: 'ri-truck-line',
                title: 'Không cần nhập hàng',
                description: 'Hệ thống tự động xử lý đơn hàng và giao hàng. Bạn chỉ cần nhận đơn và nhận hoa hồng.',
                highlight: 'Tự động hóa'
              },
              {
                icon: 'ri-percent-line',
                title: 'Hoa hồng lên đến 25%',
                description: 'Mức hoa hồng cạnh tranh nhất thị trường. Càng bán nhiều, hoa hồng càng cao.',
                highlight: 'Lên đến 25%'
              },
              {
                icon: 'ri-time-line',
                title: 'Thanh toán hàng tuần',
                description: 'Hoa hồng được thanh toán đều đặn mỗi tuần, minh bạch 100% qua hệ thống.',
                highlight: 'Hàng tuần'
              },
              {
                icon: 'ri-customer-service-line',
                title: 'Hỗ trợ 24/7',
                description: 'Đội ngũ hỗ trợ chuyên nghiệp luôn sẵn sàng giúp bạn thành công trong kinh doanh.',
                highlight: '24/7'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 lg:p-8 rounded-xl border border-orange-200 hover:border-orange-300 transition-all duration-300 hover:shadow-lg group">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-3 sm:mb-4 lg:mb-6 group-hover:bg-orange-200 transition-colors">
                  <i className={`${item.icon} text-xl sm:text-2xl text-orange-600`}></i>
                </div>
                <div className="mb-2 sm:mb-3">
                  <span className="inline-block px-2 py-1 sm:px-3 sm:py-1 bg-orange-100 text-orange-600 text-xs sm:text-sm font-medium rounded-full">
                    {item.highlight}
                  </span>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-black mb-2 sm:mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-black mb-3 sm:mb-4">
              Tính năng nổi bật
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
              Hệ thống quản lý toàn diện giúp bạn tối ưu hóa hiệu quả bán hàng
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                icon: 'ri-dashboard-line',
                title: 'Dashboard thông minh',
                description: 'Theo dõi doanh số, hoa hồng và hiệu quả bán hàng trong thời gian thực'
              },
              {
                icon: 'ri-team-line',
                title: 'Quản lý đối tác',
                description: 'Hệ thống phân cấp đối tác với thống kê chi tiết về hiệu suất'
              },
              {
                icon: 'ri-money-dollar-circle-line',
                title: 'Hoa hồng minh bạch',
                description: 'Tính toán và thanh toán hoa hồng tự động, minh bạch 100%'
              },
              {
                icon: 'ri-shopping-cart-line',
                title: 'Quản lý đơn hàng',
                description: 'Theo dõi đơn hàng từ khi tạo đến khi giao hàng thành công'
              },
              {
                icon: 'ri-bar-chart-line',
                title: 'Báo cáo chi tiết',
                description: 'Phân tích doanh thu, chi phí và lợi nhuận theo nhiều tiêu chí'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Bảo mật cao',
                description: 'Dữ liệu được mã hoá và bảo vệ với các tiêu chuẩn bảo mật quốc tế'
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 lg:p-8 rounded-xl border border-gray-200 hover:border-orange-200 transition-all duration-300 hover:shadow-lg group">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 rounded-lg flex items-center justify-center mb-3 sm:mb-4 lg:mb-6 group-hover:bg-orange-100 transition-colors">
                  <i className={`${feature.icon} text-xl sm:text-2xl text-gray-600 group-hover:text-orange-600 transition-colors`}></i>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-black mb-2 sm:mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-black mb-3 sm:mb-4 lg:mb-6">
                Bắt đầu ngay hôm nay!
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 lg:mb-8">
                Hàng nghìn đối tác đã tin tưởng và kiếm thu nhập ổn định với Navik Pro Sale
              </p>
              <div className="space-y-3 sm:space-y-4 lg:space-y-6">
                {[
                  {
                    title: 'Hoa hồng lên đến 25%',
                    description: 'Mức hoa hồng cao nhất thị trường, tăng theo doanh số bán hàng của bạn'
                  },
                  {
                    title: 'Thanh toán hàng tuần',
                    description: 'Hoa hồng được thanh toán đều đặn mỗi tuần, minh bạch và đúng hạn'
                  },
                  {
                    title: 'Đào tạo miễn phí',
                    description: 'Chương trình đào tạo bán hàng chuyên nghiệp và kỹ năng marketing'
                  },
                  {
                    title: 'Hỗ trợ marketing',
                    description: 'Cung cấp đầy đủ tài liệu, hình ảnh và video quảng cáo sản phẩm'
                  }
                ].map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-3 sm:space-x-4">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                    </div>
                    <div>
                      <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-black mb-1">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600 text-xs sm:text-sm lg:text-base">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <img
                src="https://static.readdy.ai/image/e98866bb21555bc01871226869278e9c/01fbb29660f918f49229ca24ea026fbf.jpeg"
                alt="Lợi ích của Navik Pro Sale"
                className="rounded-xl w-full object-cover h-48 sm:h-64 lg:h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-black mb-3 sm:mb-4">
              Câu chuyện thành công
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600">
              Những đối tác đã thành công với Navik Pro Sale
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                name: 'Anh Minh - TP.HCM',
                income: '15 triệu/tháng',
                story: 'Từ nhân viên văn phòng, tôi đã kiếm thêm 15 triệu mỗi tháng chỉ sau 6 tháng tham gia.',
                time: '6 tháng'
              },
              {
                name: 'Chị Lan - Hà Nội',
                income: '22 triệu/tháng',
                story: 'Bán hàng online part-time, giờ thu nhập đã vượt lương chính của tôi.',
                time: '8 tháng'
              },
              {
                name: 'Anh Tuấn - Đà Nẵng',
                income: '35 triệu/tháng',
                story: 'Nghỉ việc để tập trung bán hàng full-time, thu nhập gấp 3 lần lương cũ.',
                time: '1 năm'
              }
            ].map((story, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 lg:p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-all duration-300">
                <div className="mb-3 sm:mb-4 lg:mb-6">
                  <div className="text-lg sm:text-xl lg:text-2xl font-bold text-orange-500 mb-2">
                    {story.income}
                  </div>
                  <div className="text-sm sm:text-base lg:text-lg font-semibold text-black">
                    {story.name}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-500">
                    Sau {story.time}
                  </div>
                </div>
                <p className="text-gray-600 italic text-xs sm:text-sm lg:text-base">
                  "{story.story}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-black">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-white mb-3 sm:mb-4 lg:mb-6">
            Bắt đầu kinh doanh với 0 đồng ngay hôm nay!
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 mb-6 lg:mb-8">
            Tham gia cùng hàng nghìn đối tác đang kiếm thu nhập ổn định với Navik Pro Sale
          </p>
          <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4 justify-center">
            <Link
              to="/register"
              className="px-6 py-3 sm:px-8 sm:py-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-semibold text-base lg:text-lg inline-flex items-center justify-center whitespace-nowrap"
            >
              Đăng ký miễn phí ngay
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <a
              href="#features"
              className="px-6 py-3 sm:px-8 sm:py-4 bg-transparent text-white border border-white rounded-lg hover:bg-white hover:text-black transition-colors font-semibold text-base lg:text-lg inline-flex items-center justify-center whitespace-nowrap"
            >
              Tìm hiểu thêm
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8 sm:py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="sm:col-span-2">
              <img 
                src="https://static.readdy.ai/image/e98866bb21555bc01871226869278e9c/d81c89946136bef8b2a90450a4ebf256.png" 
                alt="Navik Pro Sale" 
                className="h-7 sm:h-8 w-auto mb-3 sm:mb-4"
                style={{ maxWidth: 'none' }}
              />
              <p className="text-gray-600 mb-4 text-sm sm:text-base">
                Nền tảng hợp tác bán hàng không cần vốn, không tồn kho. 
                Bắt đầu kinh doanh với 0 đồng và nhận hoa hồng cao.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-black mb-3 sm:mb-4 text-sm sm:text-base">Liên kết</h4>
              <ul className="space-y-2">
                <li><a href="#features" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">Tính năng</a></li>
                <li><a href="#benefits" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">Lợi ích</a></li>
                <li><a href="#zero-cost" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">Không cần vốn</a></li>
                <li><Link to="/login" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">Đăng nhập</Link></li>
                <li><Link to="/register" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">Đăng ký</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-black mb-3 sm:mb-4 text-sm sm:text-base">Liên hệ</h4>
              <ul className="space-y-2">
                <li className="text-gray-600 text-sm">Email: support@navikprosale.com</li>
                <li className="text-gray-600 text-sm">Hotline: 1900 xxxx</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
            <p className="text-gray-500 text-xs sm:text-sm">
              © 2024 Navik Pro Sale. Tất cả quyền được bảo lưu. 
              <a href="https://readdy.ai/?origin=logo" className="text-orange-500 hover:text-orange-600 ml-2">
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
